<template>
  <div class="patent-atlas-wrap">
    <div class="header-wrap">
      <div class="date">统计时间：{{ time }}</div>
      <div class="title">
        <IconWrap url="/static/patentAtlas/logo.png"></IconWrap>
        <div class="logo">华南师范大学知识产权数据图谱</div>
      </div>
    </div>
    <div class="patent-atlas-body-wrap">
      <LeftCard :dataList="dataList" :date="date"></LeftCard>
      <MidCard :dataList="dataList" :date="date"></MidCard>
      <RightCard></RightCard>
    </div>
    <div class="footerClass">
      广州奥凯信息咨询有限公司©2022-2025版权所有 数据来源于奥凯华师联合实验室
    </div>
  </div>
</template>

<script>
// 本校专利图谱
import LeftCard from './components/LeftCard.vue'
import MidCard from './components/MidCard.vue'
import RightCard from './components/RightCard.vue'
import { getchartData } from '@/api/databaseBin'
import dayjs from 'dayjs'
const mappingsTable = require('@/utils/dataMap')
const mappingsTools = require('@/utils/mapTools')
import {getBpmToken} from '@/api/back.js'
import { setStorage } from "@/utils/index";
const currentYear = dayjs().format('YYYY')
export default {
  data() {
    return {
      params: {
        firstDim: 'ORG',
        measureFields: ['authorize_num', 'application_num', 'effective_num'],
        querys: [
          {
            property: 'PUBLICATION_YEAR',
            operation: 'BETWEEN',
            value: `1986,${currentYear}`
          },
          {
            operation: 'IN',
            property: 'PATENT_TYPE',
            value: 'invent,newKind,exterior'
          },
          {
            operation: 'LESS_EQUAL',
            property: 'ORG',
            value: '6'
          }
        ],
        secondDim: 'PUBLICATION_YEAR',
        viewName: 'PATENT_COUNT_ANALYSIS'
      },
      dataList: [],
      time: '',
      date: ''
    }
  },
  components: {
    LeftCard,
    MidCard,
    RightCard
  },
  created() {
    // console.log(this.dataList)
    // if (!getStorage('bpmToken', 0)) {
    //   this.getToken()
    // }
    console.log('process.env.VUE_APP_BASE_TEMPLATEID', process.env.VUE_APP_BASE_TEMPLATEID)
    this.initSetting()
    setInterval(() => {
      this.time = dayjs().format('YYYY-MM-DD HH:mm:ss')
    }, 1000)
    this.date = dayjs().format('YYYY-MM-DD')
  },
  methods: {
    //gettoken
    async getToken() {
      const {token} = await getBpmToken()
      setStorage("bmpToken", token, 0)
    },
    async catchErr() {
      const {token} = await getBpmToken()
      setStorage("bpmToken", token, 0)
      location.reload()
    },
    // 初始化
    async initSetting() {
      const { value } = await getchartData(this.params)
      // const { value: totalValue } = await getchartData(this.totalParams);
      // const dataTotal = totalValue.reduce((pre, cur) => {
      //   pre += cur.authorize_num_total
      //   return pre
      // }, 0)
      // this.total = dataTotal;
      const data1 = value.filter(item => item.PUBLICATION_YEAR === currentYear)
      this.handlerResultMappings(data1)
      data1.forEach((item) => {
        const { ORG } = item
        switch (ORG) {
          case '华南先进光电子研究院':
            item.application_num_total = item.application_num_total + 1
            item.preOperaYear = 96
            item.curOperaYear = 94
            item.preTranYear = 3
            item.curTranYear = 1
            item.preKeepYear = 73
            item.curKeepYear = 85
            break
          case '化学学院':
            item.preOperaYear = 39
            item.curOperaYear = 31
            item.preTranYear = 2
            item.curTranYear = 0
            item.preKeepYear = 64
            item.curKeepYear = 70
            break
          case '信息光电子科技学院':
            item.preOperaYear = 55
            item.curOperaYear = 44
            item.preTranYear = 24
            item.curTranYear = 31
            item.preKeepYear = 84
            item.curKeepYear = 77
            break
          case '计算机学院':
            item.preOperaYear = 79
            item.curOperaYear = 44
            item.preTranYear = 2
            item.curTranYear = 1
            item.preKeepYear = 62
            item.curKeepYear = 71
            break
          case '生物光子学研究院':
            item.preOperaYear = 24
            item.curOperaYear = 24
            item.preTranYear = 0
            item.curTranYear = 3
            item.preKeepYear = 55
            item.curKeepYear = 48
            break
          default:
            item.preOperaYear = 18
            item.curOperaYear = 21
            item.preTranYear = 2
            item.curTranYear = 0
            item.preKeepYear = 63
            item.curKeepYear = 77
            break
        }
        const preApplication = item.application_num_total - item.application_num
        const preAuthorize = item.authorize_num_total - item.authorize_num
        const preEffective = item.effective_num_total - item.effective_num
        item.application_radio = parseFloat(((item.application_num / preApplication) * 100).toFixed(1))
        item.authorize_radio = parseFloat(((item.authorize_num / preAuthorize) * 100).toFixed(1))
        item.effective_radio = parseFloat(((item.effective_num / preEffective) * 100).toFixed(1))
        item.total = item.application_num_total
      })
      // console.log(data1);
      const datas = data1.sort(function (a, b) {
        return b.total - a.total
      })
      datas.forEach((item, index) => {
        item.id = index + 1
      })
      this.dataList = datas
    },
    // 处理数据中存在需要转换的值
    handlerResultMappings(result) {
      const v = result || []
      mappingsTools.dealResult3Map(v, mappingsTable.v2Label)
    }
  }
}
</script>
